import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { DateTimeInput, Input, Radio } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const MarkAsPaidForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues, t,
	showPaymentOptions, enableManualInstalment, isInstalment, isInstalmentChange }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Field name='paymentDate' component={DateTimeInput} showTime={true} step={1} disabled={isReadonly} horizontal required label={t('PaymentHistory_PaymentDate')} validate={[validators.required]} />
			<Field name='transaction' component={Input} disabled={isReadonly} horizontal required componentClass='textarea' label={t('PaymentHistory_Transaction')} validate={[validators.required]} />
			{showPaymentOptions && <Field name='paymentOption' component={Radio} entries={[
				{ value: 'Cash', label: t('PaymentOption_Cash') },
				{ value: 'Card', label: t('PaymentOption_Card') }
			]} inline horizontal label={t('PaymentHistory_PaymentOption')} disabled={isReadonly} />}
			{enableManualInstalment && <Field name='isInstalment' component={Radio} entries={[
				{ value: 'false', label: t('PaymentOption_FullPayment') },
				{ value: 'true', label: t('PaymentOption_IsInstalment') }
			]} inline horizontal disabled={isReadonly} onChange={isInstalmentChange}/>}
			{isInstalment && <Field name='instalmentAmount' component={Input} disabled={isReadonly} horizontal required label={t('PaymentHistory_InstalmentAmount')} validate={isInstalment && [validators.required, validators.number]} />}
		</Form>
	);
};

export default reduxForm({ form: 'markAsPaid' })(withTranslation()(MarkAsPaidForm));